import { replace } from 'react-router-redux';

import * as types from './types';
import { loading, success, error } from 'State/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { FifoEnum } from 'Common/FieldEnum';

export const getAltItems = itemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_MAINTENANCE_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `INVItem/GetAlternateItems/${itemId}`
      );
      dispatch(success(types.ALTERNATIVE_ITEMS, response));
    } catch (ex) {
      dispatch(error(types.ALTERNATIVE_ITEMS_ERROR, ex));
    } finally {
      dispatch(loading(types.ITEM_MAINTENANCE_LOADING, false));
    }
  };
};

export const getOnHandItem = itemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ON_HAND_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `INVItem/GetItemOnHand/${itemId}`
      );
      dispatch(success(types.ON_HAND_ITEMS, response));
    } catch (ex) {
      dispatch(error(types.FETCH_ON_HANDS_ERROR, ex));
    } finally {
      dispatch(loading(types.ON_HAND_ITEMS_LOADING, false));
    }
  };
};

export const getBidPriceData = itemId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.BID_PRICE_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `InvItem/GetBidPriceItems/${itemId}`
      );
      dispatch(success(types.BID_PRICE_DATA, response));
    } catch (ex) {
      dispatch(error(types.FETCH_BID_PRICE_ERROR, ex));
    } finally {
      dispatch(loading(types.BID_PRICE_LOADING, false));
    }
  };
};

export const getTransactionData = transactionObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TRANSACTION_DETAILS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'InvItem/GetTransactionDetails',
        transactionObj
      );
      dispatch(success(types.TRANSACTION_DETAILS_DATA, response));
    } catch (ex) {
      dispatch(error(types.FETCH_TRANSACTION_ERROR, ex));
    } finally {
      dispatch(loading(types.TRANSACTION_DETAILS_LOADING, false));
    }
  };
};

export const saveItems = (model, resetScroll, id) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_ITEM_DETAIL, true));
    resetScroll();

    try {
      await MPWWebApi.postGenericInsertUpdate('InvItem/SaveItem', model);
      !id && dispatch(replace('/itemmaintenance'));
      dispatch(resetDirty());
      dispatch(success(types.ITEM_DETAIL_SUBMIT));
    } catch (ex) {
      dispatch(error(types.SUBMIT_ITEM_DETAIL_ERROR, ex));
    } finally {
      dispatch(loading(types.SUBMITTING_ITEM_DETAIL, false));
    }
  };
};

export const clearError = () => {
  return {
    type: types.CLEAR_ITEM_ERROR,
  };
};

export const getFifoItems = (itemId, beginDate, endDate, selectAll) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FIFO_LOADING, true));
    const payload = selectAll
      ? {
          [FifoEnum.ItemId]: itemId,
          [FifoEnum.FromDate]: null,
          [FifoEnum.ToDate]: null,
          [FifoEnum.SelectAll]: true,
        }
      : {
          [FifoEnum.ItemId]: itemId,
          [FifoEnum.FromDate]: beginDate,
          [FifoEnum.ToDate]: endDate,
          [FifoEnum.SelectAll]: false,
        };
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'InvItem/GetFIFOItems',
        payload
      );
      dispatch(success(types.FIFO_ITEMS, response));
    } catch (ex) {
      dispatch(error(types.FETCH_FIFO_ITEMS_ERROR, ex));
    } finally {
      dispatch(loading(types.FIFO_LOADING, false));
    }
  };
};

export const printReportData = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_REPORT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'INVItem/GetFIFOTranHistoryPrint',
        payload
      );
      dispatch(success(types.GET_REPORT, response.data.Data.Data));
    } catch (err) {
      dispatch(error(types.PRINT_REPORT_ERROR, err));
    } finally {
      dispatch(loading(types.PRINT_REPORT_LOADING, false));
    }
  };
};

export const clearReport = () => {
  return {
    type: types.CLEAR_REPORT,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/addEditItem/actions.js